module.exports = __webpack_public_path__ + "img/danger_icon.6eb49cf1.svg";